import React from 'react';
import * as _ from 'lodash';

import { FieldItemService } from '../../../services/FieldItems';
import { FIELD_ITEM_LISTS } from '../../../utilities/constants';
import InfinityScrollLoad from '../../InfinityScrollLoad';
import SessionStorageService from '../../../services/utilities/SessionStorageService.js';
import { isNullOrEmpty } from '../../../utilities/stringUtil.js';
import { messageUtility } from '../../../utilities/messageUtility';
import { ArrowDownIcon } from '../../icons/ArrowDownIcon';
import {
  FormElement,
  FormDropdownRadio,
  FormDropdownClearButton,
} from '../../CommonFormComponents';
/**
 * FieldItemDropdownのベース
 *
 * @export
 * @class FieldItemBaseDropdown
 * @extends {React.Component}
 */
export default class FieldItemBaseDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: SessionStorageService.getFieldId(),
      loaded: props.options ? true : false,
      allLoaded: false,
      opened: false,
      options: props.options || [], // 選択項目リスト
      error: '',
      condition: {
        name: '',
      },
      offset: 0,
      selected: null, // 選択協力会社情報(id)
      selectedName: '', // 選択協力会社情報(name)
      temporarySelected: null, // 選択協力会社情報temp(id)
      temporarySelectedName: '', // 選択協力会社情報temp(id)
      isLoading: props.options ? false : true, // ロード中フラグ
    };

    // propsのfieldItemTypeから切替用の情報を取得
    this.template = FIELD_ITEM_LISTS[props.fieldItemType];

    // ユニークID生成
    this.id = _.uniqueId();
    this.targetId = `infinityscroll-target-dropdown-${this.id}`;
    this.search = this.search.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.setCondition = this.setCondition.bind(this);
    this.handleSelectedRow = this.handleSelectedRow.bind(this);
    this.getFieldItems = this.getFieldItems.bind(this);
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
    this.handleInview = this.handleInview.bind(this);
    this.setValue = this.setValue.bind(this);
    this.searchTimer;
  }

  componentDidMount() {
    if (_.isUndefined(this.props.loaded)) {
      this.getFieldItems();
    } else {
      this.setState({
        isLoading: false,
        loaded: this.props.loaded || false,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    // 親コンポーネントから配列(option)の情報が渡ってきているか
    if (
      nextProps.loaded === true &&
      !_.isUndefined(nextProps.options) &&
      !_.isEqual(nextProps.options, this.state.options)
    ) {
      this.setState({
        options: nextProps.options,
        loaded: nextProps.loaded,
        isLoading: false,
      });
    } else if (_.isUndefined(nextProps.loaded)) {
      this.getFieldItems();
    }
    // valueが変わっていたら外から変更されたことなのでコンポーネント内のstateを合わせる
    if (_.toString(nextProps.value) !== _.toString(this.state.selected)) {
      // valueに値がある場合のみnameもセット(valueが空でもnameが空にならない)
      const isSetValue = !isNullOrEmpty(nextProps.value);
      this.setState({
        selected: isSetValue ? nextProps.value : null,
        selectedName: isSetValue ? nextProps.name : '',
        temporarySelected: isSetValue ? nextProps.value : null,
        temporarySelectedName: isSetValue ? nextProps.name : '',
      });
    }
  }

  componentDidUpdate() {
    if (this.state.opened === true) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (this.state.opened === false) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.setState({ opened: false });

    if (_.isFunction(this.props.validate)) {
      this.props.validate(this.props.column);
    }
  };

  handleOpen = () => {
    // 初期化
    let { opened, selected, selectedName } = { ...this.state };
    if (opened === false) {
      // プルダウンを表示した際、temporarySelectedに選択済みのidを入れる
      this.setState({
        opened: true,
        loaded: true,
        temporarySelected: selected,
        temporarySelectedName: selectedName,
      });
    } else {
      this.setState({ opened: false });
      if (_.isFunction(this.props.validate)) {
        this.props.validate(this.props.column);
      }
    }
  };

  setCondition = e => {
    let condition = this.state.condition;
    condition.name = e.target.value;
    this.setState({ condition });

    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.search();
    }, 1000);
  };

  search = () => {
    this.setState(
      {
        options: [],
        loaded: false,
        allLoaded: false,
        isLoading: true,
      },
      () => {
        this.getFieldItems();
      }
    );
  };

  handleInview() {
    if (this.state.loaded && !this.state.allLoaded) {
      this.setState({
        loaded: false,
      });
      this.getFieldItems();
    }
  }

  handleSelectedRow = (id, checked) => {
    let { temporarySelected, temporarySelectedName } = { ...this.state };
    if (checked === true) {
      // 選択済みの情報のみselectedRowへ
      temporarySelected = id;
      const selectedRow = _.find(this.state.options, { id });
      // 選択した名前をtempへ
      temporarySelectedName = selectedRow.name;
    } else {
      temporarySelected = null;
      temporarySelectedName = '';
    }

    this.setState(
      {
        temporarySelected,
        temporarySelectedName,
      },
      () => {
        this.setValue();
      }
    );
  };

  clearSelectedRow = () => {
    this.setState({ selected: null, selectedName: '', opened: false }, () => {
      this.props.set(this.template.propName, null);
    });
  };

  setValue = () => {
    let { selected, selectedName } = { ...this.state };
    // temp情報をselect~に入れる
    selected = this.state.temporarySelected;
    selectedName = this.state.temporarySelectedName;
    this.setState(
      {
        selected,
        selectedName,
        opened: false,
      },
      () => {
        this.props.set(this.template.propName, selected);
      }
    );
  };

  async getFieldItems() {
    if (this.state.loaded) {
      this.setState({ isLoading: false });
      return;
    }

    const params = {
      field_id: this.state.fieldId,
      item_list_ids: this.template.id,
      is_limit: 1,
      limit: 30,
      offset: _.size(this.state.options),
      name: this.state.condition.name,
      // 有効のものだけ表示
      display_flag: 1,
    };

    const doApi = async () => {
      // 現場作業エリア情報取得API
      FieldItemService.list(this.state.fieldId, params).then(response => {
        if (response.result === false) {
          this.setState({ isLoading: false });
          return;
        }
        const fieldItemLists =
          response.data.entities[this.template.entitiesName];
        const allLoaded = _.size(fieldItemLists) < params.limit;
        const options = this.state.options;
        _.each(fieldItemLists, fieldItemList => {
          if (_.findIndex(options, { id: fieldItemList.id }) < 0) {
            options.push(fieldItemList);
          }
        });

        this.setState({
          options,
          loaded: true,
          allLoaded,
          isLoading: false,
        });
      });
    };
    await doApi();
  }

  render() {
    const isOptional = _.isBoolean(this.props.isOptional)
      ? this.props.isOptional
      : true;
    const getName = () => {
      let name = `${this.props.title}を選択`;

      const option = _.find(this.state.options, {
        id: this.state.selected,
      });
      if (option) {
        name = option.name;
      } else {
        name = this.state.selectedName || name;
        if (this.props.readOnly && !this.state.selectedName) {
          name = '';
        }
      }

      return name;
    };

    if (this.props.isFormListDefault && this.props.readOnly) {
      return (
        <FormElement>
          <div>{getName()}</div>
        </FormElement>
      );
    }
    return (
      <FormElement validate={this.props.error}>
        <div
          className={`form-dropdown dropdown-multi-select ${!this.props
            .isFormListDefault &&
            '--col-xs-12 --col-md-12 --col-lg-5 --col-xl-5'}`}
        >
          {this.props.readOnly ? (
            <input
              disabled
              type='text'
              className=' --col-xl-5 --col-lg-5 --col-md-10 --col-xs-10'
              value={getName()}
            />
          ) : (
            <div ref={this.parent}>
              <div
                className={`dropdown-multi-select__header ${
                  this.state.opened ? 'show' : ''
                }`}
              >
                <div
                  id='form-dropdown-btn'
                  href=''
                  className='dropdown-select'
                  onClick={this.handleOpen}
                >
                  <span className='dropdown-select__txt'>{getName()}</span>
                </div>
                <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
              </div>
              {this.state.opened && (
                <div
                  id='form-dropdown-list'
                  className='dropdown dropdown--dropdown-list show'
                >
                  <div className='dropdown__item dropdown__item--hidden'>
                    <div className='dropdown-single-select__item'>
                      <i className='i-search i-2x' />
                      <input
                        type='text'
                        className='--col-xs-12 --col-md-12 --col-lg-12 --col-xl-12'
                        placeholder={messageUtility.getMessage('I-000-090')}
                        defaultValue={this.state.condition.name}
                        onChange={this.setCondition}
                      />
                    </div>
                    {isOptional && (
                      <div className='dropdown-single-select__item'>
                        <FormDropdownClearButton
                          onClick={this.clearSelectedRow}
                        />
                      </div>
                    )}
                    <div className='dropdown-single-select__item'>
                      <div
                        className='dropdown-single-select__scroll'
                        id={this.targetId}
                      >
                        <ul className='single-select'>
                          {_.map(this.state.options, (option, index) => (
                            <FormDropdownRadio
                              key={index}
                              option={option}
                              checked={
                                this.state.temporarySelected === option.id
                              }
                              targetId={this.id}
                              handleSelectedRow={this.handleSelectedRow}
                              forId='single-field-item-id'
                            />
                          ))}
                          <InfinityScrollLoad
                            targetId={this.targetId}
                            total={_.size(this.state.options)}
                            isLoading={this.state.isLoading}
                            callback={this.handleInview}
                            ignoreIndicator={true}
                          />
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </FormElement>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/FieldItemBase.jsx